
// Dashboard
import Dashboard from './components/Dashboard/Dashboard';

// User
import GroupMaster from './components/UserMaster/GroupMaster';
import GroupMenu from './components/UserMaster/GroupMenuAccess';
import ResetPassword from './components/UserMaster/ResetPassword';
import UserMaster from './components/UserMaster/UserMaster';

// Masters
import BranchMaster from './components/Master/BranchMaster';
import ChargeTypeMaster from './components/Master/ChargeTypeMaster';
import CityMaster from './components/Master/CityMaster';
import CompanyMaster from './components/Master/CompanyMaster';
import CountryMaster from './components/Master/CountryMaster';
import FlightMaster from './components/Master/FlightMaster';
import StateMaster from './components/Master/StateMaster';
import TrainMaster from './components/Master/TrainMaster';
import { CommingSoon } from './components/CommonComponents/ComingSoon';
import AWBNoQuery from './components/Query/AWBNoQuery';
import Home from './components/Layout/Home';
import ChangePassword from './components/UserMaster/ChangePassword';
import Shipment from './components/Shipment/Shipment';
import ShipmentReport from './components/Shipment/ShipmentReport';
import PickupPointMaster from './components/Master/PickupPointMaster';
import CNotePrint from './components/Print/CNotePrint';
import LabelPrint from './components/Print/LabelPrint';


export const protectedRoutes = [
    { path: "Dashboard/Dashboard", component: Dashboard },
    { path: "Dashboard/Index", component: Home },
    { path: "*", component: CommingSoon },

    // User
    { path: "/User/UserMaster", component: UserMaster },
    { path: "/User/Resetpassword", component: ResetPassword },
    { path: "/User/Groupmaster", component: GroupMaster },
    { path: "/User/GroupMenuAccess", component: GroupMenu },
   

    // Masters
    { path: "/Master/BranchMaster", component: BranchMaster },
    { path: "/Master/Citymaster", component: CityMaster },
    { path: "/Master/Statemaster", component: StateMaster },
    { path: "/Master/Countrymaster", component: CountryMaster },
    { path: "/Master/Companymaster", component: CompanyMaster },
    { path: "/Master/ChargeTypeMaster", component: ChargeTypeMaster },
    { path: "/Master/FlightMaster", component: FlightMaster },
    { path: "/Master/TrainMaster", component: TrainMaster },
    { path: "/Query/AWBNoQuery", component: AWBNoQuery },
    { path: "/Master/PickupPointMaster", component: PickupPointMaster },

    //ClientUser
    { path: "/ClientUser/ChangePassword", component: ChangePassword },

    //Print
    { path: "/CNotePrint", component: CNotePrint },
    { path: "/LabelPrint", component: LabelPrint },


    //Shipment
    { path: "/Shipment/Shipment", component: Shipment },
    { path: "/Shipment/ShipmentReport", component: ShipmentReport },

];
